var e = "10.32.0+unknown";
//#endregion
export { e as REPORT_PACKAGE_VERSION };
